import { DocumentationCardItem } from '../salesforce-documentation-card/types';
import { useSelector } from 'react-redux';
import { selectDocumentationCardItem } from '../../../reducers/documentation/documentationCardReducer';
import { SearchResponseWithConfigurationItems } from './types';
import { UniversalSearchList } from './UniversalSearchList';
import { SingleSelectFilterPopoverOption } from '../../common/filters/single-select-filter/SingleSelectFilterPopover';
import { useUniversalSearchContext } from './UniversalSearchContext';
import { sortSearchResults } from './sortSearchResults';
import { useMemo } from 'react';
import { SalesforceItem } from '../../parser/ParserTypes';
import { SearchResultsContent } from '../building-blocks/search/SearchResultsContent';

interface UniversalSearchContentProps {
  onListItemClick: (props: DocumentationCardItem) => void;
  showLoader?: boolean;
  results?: SearchResponseWithConfigurationItems;
  isLoadingResults?: boolean;
  crmOrgId: string;
  filterOptions: SingleSelectFilterPopoverOption[];
  onSelectedFilterItem: (key?: string) => void;
  selectedFilterValue?: string;
  isExpandedMode: boolean;
  renderRightElement?: (item: SalesforceItem, isHovered: boolean) => React.ReactNode | null;
  getItemStyling?: (item: SalesforceItem) => object;
  emptyState?: React.ReactNode;
  forceRenderIcons?: boolean;
}

export const UniversalSearchContent = ({
  onListItemClick,
  showLoader,
  results,
  isLoadingResults,
  filterOptions,
  selectedFilterValue,
  onSelectedFilterItem,
  isExpandedMode,
  crmOrgId,
  renderRightElement,
  getItemStyling,
  emptyState,
  forceRenderIcons,
}: UniversalSearchContentProps) => {
  const { searchTxt } = useUniversalSearchContext();

  const noResults = !!results && Object.values(results).every((result) => result?.length === 0);

  const selectedCardItem = useSelector(selectDocumentationCardItem);
  const activeItem = selectedCardItem?.item;
  const activeItemId = activeItem?.id
    ? activeItem.id
    : activeItem?.name ?? activeItem?.metadataId;

  const configurationItems = useMemo(
    () =>
      results ? Object.values(sortSearchResults(results, crmOrgId, searchTxt)).flat() : undefined,
    [crmOrgId, results, searchTxt],
  );

  return (
    <SearchResultsContent
      isLoading={!!isLoadingResults}
      hasSearched={!!results && !!searchTxt}
      noResults={noResults}
      emptyState={emptyState}
    >
      {configurationItems && (
        <UniversalSearchList
          filterOptions={filterOptions}
          selectedFilterValue={selectedFilterValue}
          onSelectedFilterItem={onSelectedFilterItem}
          activeItemId={activeItemId}
          configurationItems={configurationItems}
          onListItemClick={onListItemClick}
          showLoader={showLoader}
          isExpandedMode={isExpandedMode}
          renderRightElement={renderRightElement}
          getItemStyling={getItemStyling}
          forceRenderIcons={forceRenderIcons}
        />
      )}
    </SearchResultsContent>
  );
};
